<template>
	<el-drawer title="批量设置第三方销售" :visible.sync="drawerShow" :wrapperClosable="false" :destroy-on-close="true"
		size="650px" :show-close="false">
		<div class="drawer-content">
			<div>
				<p class="font16">选择模式：</p>
				<el-radio-group size="medium" v-model="isIncrement" class="MT15" >
					<el-radio :label="1">增量模式（对选中的演出,增加下面选择的渠道）</el-radio>
					<el-radio :label="0">覆盖模式（按选中覆盖）</el-radio>
				</el-radio-group>
			</div>
			<div v-if="thirdAccount" class="page-list-box">
				<span class="font16">选择渠道：</span>
				<el-checkbox-group size="medium" v-model="thirds" class="MT10" @change="changeThird">
					<el-checkbox v-for="(v,i) in thirdAccount" :key="i" :label="v.source"
						class="MT10 MR10">{{v.thirdName}}</el-checkbox>
				</el-checkbox-group>
			</div>
			<!-- <div class="color-warning">选择设置的第三方渠道,会覆盖所选 <span class="font20 color-danger">{{activityIds.length}}</span>
				个演出下的所有场次,<br>请谨慎操作!</div> -->
			<template v-if="showPoster">
				<div class="MT30">
					<p class="font16">大麦海报操作模式：</p>
					<el-radio-group size="medium" v-model="isDamai" class="MT15" @change="searchEvent()">
						<el-radio :label="2">按巡演（合并选中的演出按巡演来操作）</el-radio>
						<el-radio :label="1">按单场（按单场处理）</el-radio>
					</el-radio-group>
				</div>
				<div v-if="tourList && tourList.length  > 0 && isDamai == 2" class="MT15">
					<el-table :data="tourList" border style="width: 100%" v-loading="dataLoading" size="small"
						stripe>
						<el-table-column prop="tourId" label="巡演ID" width="100">							
						</el-table-column>
						<el-table-column prop="name" label="巡演名称" show-overflow-tooltip>							
						</el-table-column>
						<el-table-column prop="poster" label="海报">
							<template slot-scope="scope" v-if="scope.row.poster"><el-image
									:src="scope.row.poster | coverImage(60,60)" fit="cover"
									:preview-src-list="[scope.row.poster]"></el-image></template>
						</el-table-column>
						<el-table-column prop="poster" label="上传海报" width="150">
							<template slot-scope="scope">
								<p v-if="scope.row.poster">
									<el-button type="text" size="small" icon="el-icon-edit"
										@click="upload(scope.row)">编辑</el-button>
								</p>
								<p v-else>
									<el-button type="text" size="small" icon="el-icon-upload"
										@click="upload(scope.row)">上传</el-button>
								</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-if="activityExceptTour && activityExceptTour.length  > 0 && isDamai == 2" class="MT15">
					<el-table :data="activityExceptTour" border style="width: 100%" v-loading="dataLoading" size="small"
						stripe>
						<el-table-column prop="id" label="演出ID" width="100">							
						</el-table-column>
						<el-table-column prop="name" label="演出名称" show-overflow-tooltip>							
						</el-table-column>
						<el-table-column prop="poster" label="海报">
							<template slot-scope="scope" v-if="scope.row.poster"><el-image
									:src="scope.row.poster | coverImage(60,60)" fit="cover"
									:preview-src-list="[scope.row.poster]"></el-image></template>
						</el-table-column>
						<el-table-column prop="poster" label="上传海报" width="150">
							<template slot-scope="scope">
								<p v-if="scope.row.poster">
									<el-button type="text" size="small" icon="el-icon-edit"
										@click="upload(scope.row)">编辑</el-button>
								</p>
								<p v-else>
									<el-button type="text" size="small" icon="el-icon-upload"
										@click="upload(scope.row)">上传</el-button>
								</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div v-if="activityList && activityList.length  > 0 && isDamai == 1" class="MT15">
					<el-table :data="activityList" border style="width: 100%" v-loading="dataLoading" size="small"
						stripe>
						<el-table-column prop="id" label="演出ID" width="100">							
						</el-table-column>
						<el-table-column prop="name" label="演出名称" show-overflow-tooltip>							
						</el-table-column>
						<el-table-column prop="poster" label="海报">
							<template slot-scope="scope" v-if="scope.row.poster"><el-image
									:src="scope.row.poster | coverImage(60,60)" fit="cover"
									:preview-src-list="[scope.row.poster]"></el-image></template>
						</el-table-column>
						<el-table-column prop="poster" label="上传海报" width="150">
							<template slot-scope="scope">
								<p v-if="scope.row.poster">
									<el-button type="text" size="small" icon="el-icon-edit"
										@click="upload(scope.row)">编辑</el-button>
								</p>
								<p v-else>
									<el-button type="text" size="small" icon="el-icon-upload"
										@click="upload(scope.row)">上传</el-button>
								</p>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</template>

		</div>
		<div class="drawer-footer">
			<el-button v-if="!btnLoading" @click="close">关闭</el-button>
			<el-button type="primary" :loading="btnLoading" @click="submitThirdAll">提交</el-button>
		</div>
		<upload-poster ref="UploadPoster"></upload-poster>
	</el-drawer>
</template>

<script>
	import {
		fetchThirdAccount
	} from '@/assets/js/commonApi';
	import UploadPoster from './upload-poster';
	export default {
		props: {
			id: {
				type: [Number, String],
				default: 1
			},
			activityIds: {
				type: Array,
				default: () => []
			},
			tourIds: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {
				drawerShow: false,
				btnLoading: false,
				canSubmit: false,
				thirdAccount: [],
				thirds: ['baoma', 'beizhan'],
				isIncrement:'',
				isDamai:'',
				sessionThirdTemplateListVO: {
					activityIds: [],
					thirds: []
				},
				activityList: [],
				tourList:[],
				activityExceptTour:[],
				dataLoading: false,
				innerDrawer: false,
				showPoster: false,
				daMaiActivityPoster:[],
				daMaiTourPoster:[]
			};
		},
		components: {
			UploadPoster
		},
		methods: {
			show() {
				this.drawerShow = true;
				this.getThirdAccount();
				//this.searchEvent();
			},
			close() {
				this.fileList = [];
				this.activityList = [];
				this.tourList = [];
				this.activityExceptTour = [];
				this.isDamai = ''
				this.drawerShow = false;
				this.showPoster = false;
				this.thirds = ['baoma', 'beizhan']
			},
			//获取第三方平台
			getThirdAccount() {
				fetchThirdAccount({
						isThird: 1
					})
					.then((res) => {
						const {
							state,
							result
						} = res.data;
						if (state == 1 && result) {
							this.thirdAccount = result.thirdAccounts || [];

						} else {
							// this.$message.error(msg || "请求失败");
						}
					})
			},
			changeThird() {
				if (this.thirds.includes('damai')) {
					this.showPoster = true					
				}else{
					this.showPoster = false
				}
			},
			searchEvent(){
				var ids = Object.values(this.activityIds);
				this.dataLoading = true;
				this.$request({
						url: "/shop_good/activity",
						params: {
							activityId: ids.toString(),
							type: 1
						},
						method: "post",
					})
					.then((res) => {
						const {
							state,
							result,
							msg
						} = res.data;
						if (state == 1 && result && result.length > 0) {
							
							this.activityList = result   //所选演出的集合
							var _result = result
							// console.log(_result)
							var _arr = _result.filter((item, index, self) =>index === self.findIndex((i) => ( i.tourId && i.tourId === item.tourId )))
							this.tourList = _arr // 巡演数据
							// console.log(this.tourList)
							var _arr2 =  _result.filter(item => !item.tourId);
							this.activityExceptTour = _arr2 // 所选演出没有巡演的
							this.dataLoading = false
						} else {
							this.$message.error(msg || '没有找到相关演出');
							this.dataLoading = false
						}
					})
			},
			
			//编辑事件
			upload(data) {
				this.$refs.UploadPoster.show(data);
			},
			submitThirdAll() {	
				
				if ( this.isIncrement === '' ) {
					return this.$message.error("请先选择模式！")
				}
				if (this.thirds.length === 0) {
					return this.$message.error("请先选择渠道模板！")
				}
				
				var _Isposter1 = 0, _Isposter2 = 0 , _Isposter3 = 0 ;  //1.演出 2.巡演
				
				if( this.isDamai == 2 && this.tourList && this.tourList.length > 0 ){
					this.tourList.forEach((item,index) => {
						if( !item.poster || item.poster == '' ){
							_Isposter1 = 1
						}
						
					})
					if( _Isposter1 == 1 && this.thirds.includes('damai') ){
						return this.$message.error("巡演海报不能为空，请上传海报")
					}
					this.tourList.forEach((item,index) => {
						this.daMaiTourPoster.push({
							id:item.tourId,
							name:item.poster
						})
					})					
				}
				if( this.isDamai == 2 && this.activityExceptTour && this.activityExceptTour.length > 0  ){
					this.activityExceptTour.forEach((item,index) => {
						if( !item.poster || item.poster == '' ){
							_Isposter2 = 1
						}
						
					})
					if( _Isposter2 == 1 && this.thirds.includes('damai') ){
						return this.$message.error("演出海报不能为空，请上传海报")
					}
					this.activityExceptTour.forEach((item,index) => {
						this.daMaiActivityPoster.push({
							id:item.id,
							name:item.poster
						})
					})
				}
				if( this.isDamai == 1 && this.activityList && this.activityList.length > 0 ){					
					this.activityList.forEach((item,index) => {
						if( !item.poster || item.poster == '' ){
							_Isposter3 = 1
						}						
					})
					if( _Isposter3 == 1 && this.thirds.includes('damai') ){
						return this.$message.error("演出海报不能为空，请上传海报")
					}
					this.activityList.forEach((item,index) => {
						this.daMaiActivityPoster.push({
							id:item.id,
							name:item.poster
						})
					})					
				}				
				
				this.$confirm('确定批量设置第三方销售到所选演出下所有场次吗？', '批量设置第三方销售', {}).then(() => {
					this.btnLoading = true
					this.sessionThirdTemplateListVO.activityIds = this.activityIds
					this.sessionThirdTemplateListVO.thirds = this.thirds
					this.sessionThirdTemplateListVO.isIncrement = this.isIncrement
					this.sessionThirdTemplateListVO.daMaiActivityPoster = this.daMaiActivityPoster
					this.sessionThirdTemplateListVO.daMaiTourPoster = this.daMaiTourPoster

					this.$request({
							url: "/activity/saveAndApplyThirdTemplate",
							method: "post",
							data: {
								sessionThirdTemplateListVO: this.sessionThirdTemplateListVO
							},
						})
						.then((res) => {
							//处理成功回调
							const {
								state,
								msg
							} = res.data;
							if (state && state == 1) {
								this.$message.success('操作成功');
								this.close();
								this.$emit('onUpdate');

							} else {
								return this.$message.error(msg || "操作失败");
							}
						})
						.finally(() => {
							this.btnLoading = false;
						});


				}).catch(() => {

				})
			}

		},
	};
</script>

<style lang="scss" scoped>
	.font20 {
		font-size: 20px;

	}

	.font16 {
		font-size: 16px;

		small {
			font-size: 10px
		}
	}

	::v-deep .page-list-box {
		margin: 40px 0 20px;
	}
</style>